export default __webpack_public_path__ + "static/siteLogo2-f3fac083b24f178ca3f142c82593b0c9.png";